import { useQuery } from '@tanstack/react-query';
import { announcementService } from '../services/announcementService';

/**
 * Banners del portal.
 *
 * `staleTime` de 5 min: el backend ya cachea el JSON de storage
 * (`BANNER_CACHE_TTL_SECONDS`, 60s por defecto), así que pedirlo en cada
 * navegación solo agrega latencia. A cambio, apagar un banner desde el panel
 * tarda hasta ~6 min en desaparecer de una pestaña ya abierta — aceptable para
 * contenido editorial, y con recargar se ve al instante.
 *
 * `retry: false` a propósito: si el endpoint falla, la franja no se muestra y
 * ya está. Reintentar tres veces por un banner es gastar red en lo accesorio.
 */
export function useBanners(enabled: boolean = true) {
  return useQuery({
    queryKey: ['portal-banners'],
    queryFn: () => announcementService.getBanners(),
    staleTime: 5 * 60 * 1000,
    retry: false,
    enabled,
  });
}
